export default {
  title: '¿Qué te parece {{name}}?',
  description: 'Tu opinión es anónima y nos ayuda a mejorar.',
  upload_google_review: {
    title: 'Déjanos una reseña y consigue recompensas',
  },
};
